import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import billSetSaga from "./nonauth/billingdetails/saga"
import HomeSaga from "./menu/home/saga"
import ApplicationSaga from "./menu/application/saga"
import PlanSaga from "./nonauth/plan/saga"
import UsageSaga from "./menu/usage/saga"
import PricingSaga from "./menu/pricing/saga"




// lystface

export default function* rootSaga() {
  yield all([
    //public
    billSetSaga(),
    PlanSaga(),
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    HomeSaga(),
    ApplicationSaga(),
    fork(LayoutSaga),
    UsageSaga(),
    PricingSaga(),

  ])
}
